import { useTranslation } from 'react-i18next'

import { ProgramDetailTable } from './Shared/ProgramDetailTable'
import { EligibilityCheck } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { Flex, Typography } from '@percent/lemonade'

export function ProgramEligibilityDetails({ rules }: EligibilityCheck) {
  const { t } = useTranslation()

  if (!rules?.length) return null

  return (
    <Flex gap={16} direction="column">
      <Typography variant="h4">{t('typography.eligibility')}</Typography>
      <ProgramDetailTable
        title={t('program.label.eligibilityRules')}
        items={rules.filter(({ name }) => !!name).map(({ name }) => name) as string[]}
      />
    </Flex>
  )
}
